import produce from "immer";
import { atom } from "jotai";
import { atomWithImmer } from "jotai/immer";
// @ts-ignore
var initialAppStage = {
  currentURL: "",
  lastPing: Date.now(),
  selectedProjectId: null
};
export var appStateAtom = atomWithImmer(initialAppStage);
appStateAtom.debugLabel = "appState";
/*
	Mutator and selector for these atom
 */

export var appStateItemMutator = atom(null, function (get, set, _ref) {
  var key = _ref.key,
      value = _ref.value;
  var appState = get(appStateAtom);
  var newState = produce(appState, function (newState) {
    // @ts-ignore
    newState[key] = value;
  });
  set(appStateAtom, newState);
});